export default {
  SAVE_SUPERVISE_CONTRACT: '/econo/superviseContract/save', // 保存监管合同
  EXPORT_SUPERVISE_CONTRACT_EXCEL: '/econo/superviseContract/export', // 导出excel
  GET_DETAIL_BY_ID: '/econo/superviseContract/detail', // 根据id获取详情
  CLOSE_CONTRACT_BY_ID: '/econo/superviseContract/close', // 根据id关闭
  APPROVAL_SUPERVISE_CONTRACT: '/econo/superviseContract/apploval', // 审批
  GET_PAGE_DATA: '/econo/superviseContract/page', // 分页获取数据
  WITHDRAWAL_CONTRACT: '/econo/superviseContract/withdrawal', // 监管合同撤回
  DELETE_CONTRACT_BY_ID: '/econo/superviseContract/delete', // 删除监管合同单
  GET_CONTRACT_DETAIL_BY_ID: '/econo/superviseContract/detail', // 根据id获取详情
};
